<div class="col-sm-12 offset-md-1 col-md-10  mt-3">
    <div class="form-logo">
        <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL','','_self');">
            <img [src]="this.logo_url" alt="egd-logo">
        </a>
    </div>
    <div class="form-back  h4 my-4">
        <a [routerLink]="['/', this.slug, 'user', 'login', 'patient']">&#8592; Back</a>
    </div>
    <div class="form-heading-section mt-4">
        <h2>Confirm Email</h2>
        <p class="form-sub-heading">
            Don't worry we've got you covered.
        </p>
        <p class="form-tagline"><small>Verify your Email</small></p>
        <!-- <p class="text-center forgot-pass-info"><small>Password reset link will be sent to your Email
                id.</small></p> -->
    </div>
    <div class="container ml-lg-5 pl-lg-5">        
        <div class="form-div my-4">
            <ng-container *ngIf="this.verifyUserid_data.tabViewData.selected_tab==0">
                <form #userIdForm="ngForm" autocomplete="off" (ngSubmit)="userIdFormSubmit()" accept-charset="UTF-8" *ngIf="this.verifyUserid_data.userid_data.toggle_Reset">
                    <div class="form-group row">
                        <userid-input class="col-lg-9 col-md-12 col-sm-12 ml-1" [userid_data]="this.verifyUserid_data.userid_data"></userid-input>
                    </div>
                    <div class="form-group row mx-md-4 ml-sm-2 ml-md-3">
                        <div class="m-3">
                            <div id="recaptcha-div2">
                                <re-captcha *ngIf="this.verifyUserid_data.recaptchaData.recaptcha_Reset"
                                    class="recaptcha ng-valid" name="recaptcha" matInput style="display: inline-block;"
                                    (resolved)="resolved($event)"
                                    [(ngModel)]="this.verifyUserid_data.verify_modal.recaptcha" #recaptcha="ngModel"
                                    [siteKey]="sitekey" required>
                                </re-captcha>
                            </div>
                        </div>
                    </div>
    
                    <div class="form-group row">
                        <div class="col-lg-9 col-sm-12">
                            <div class="form-submit-button mt-5 ml-lg-2">
                                <button type="submit" [disabled]="!userIdForm.valid || isPosting()"
                                    class="btn btn-primary font-weight-bold text-white p-2">
                                    Continue
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
                <!-- <div class="form-submit-button mt-2">
                    <button type="button" class="btn btn-primary font-weight-bold text-white p-2" *ngIf="resendDone==true"
                        routerLink="/user/login/patient">
                        Back
                    </button>
                </div> -->
            </ng-container>
            <ng-container *ngIf="this.verifyUserid_data.tabViewData.selected_tab==1">
                <div class="form-heading-section mt-4">
                    <p class="form-sub-heading">
                        We have sent an OTP on
                    </p>
                    <h2>{{this.verifyUserid_data.verify_modal.e_email}}</h2>
    
                </div>
                <form #otpForm="ngForm" (ngSubmit)="otpVerifySubmit()" accept-charset="UTF-8" id="register_form">
                    <div class="form-group row">
                        <otp-input class="col-12" [isPrimeNg]="false" [otp_data]="this.verifyUserid_data.otp_data"
                            (otp_resend)="otp_resend()">
                        </otp-input>
                    </div>
    
                    <div class="form-group row">
                        <div class="col-lg-9 col-sm-12">
                            <div class="form-submit-button  my-3">
                                <button type="submit" class="btn btn-primary font-weight-bold text-white p-2"
                                    [disabled]="isPosting() || !otpForm.valid">
                                    Verify
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </ng-container>
            <ng-container *ngIf="this.verifyUserid_data.tabViewData.selected_tab==2">
                <div class="alert alert-success">
                    {{this.verifyUserid_data.otp_data.otp_api_result.PromiseResult.data.message}}
                </div>
                <div class="form-group row">
                    <div class="col-sm-12">
                        <div class="form-submit-button mt-5">
                            <button type="button" [routerLink]="['/', this.slug, 'user', 'login', 'patient']"
                                class="btn btn-primary font-weight-bold text-white p-2">
                                Login
                            </button>
                        </div>
                    </div>
                </div>
            </ng-container>
            <div class="mt-3 mx-2">
                <div class="row">
                    <app-loading class="col-12 text-center" *ngIf="isPosting()" type="SMALL_LOADER">
                    </app-loading>
                </div>
                <app-error-messages [api_result]=" this.verifyUserid_data.verify_api_result"></app-error-messages>
    
                <app-error-messages [api_result]=" this.verifyUserid_data.otp_data.otp_api_result">
                </app-error-messages>
            </div>
        </div>
    </div>
    


    <div class="footer-copyright-section mt-4">
        <p class="footer-copyright-text text-center">
            2025 Copyright <span>&#169;</span> All rights reserved by <a href="javascript:void(0)"
                (click)="openLink('HOMPAGE_BASE_URL','','_self');" style="color: #1850A0;">eGlobalDoctors</a>
        </p>
    </div>

</div>